// AUTO-GENERATED — run pnpm knowledge:sync
// Do not edit by hand.

import type { CatalogSkill } from "../types.js";

export const localSkills = [
  {
    "id": "agent-workflow",
    "name": "agent-workflow",
    "packageName": "@eristack/ai-knowledge",
    "description": "Agent workflow for @eristack: four design targets (cheap tokens, predictable, reliable, clear boundaries — consumers must not reinvent exports), recommend first, load skills before coding, prefer examples, HARD RULE docs+skills+ recipes + pnpm knowledge:sync every iteration. Use for multi-package work or monorepo contributions.",
    "type": "core",
    "loadCommand": "pnpm dlx @tanstack/intent@latest load @eristack/ai-knowledge#agent-workflow"
  },
  {
    "id": "ai-toolbox",
    "name": "ai-toolbox",
    "packageName": "@eristack/ai-knowledge",
    "description": "Practical AI agent toolbox for Eristack: feature-brief prompts, skill-load order, money/auth/doc-number guardrail checklists, and recipe-authoring template for keeping @eristack/ai-knowledge discoverable. Use when briefing agents, reviewing plans, or adding recipes after new package capabilities.",
    "type": "core",
    "loadCommand": "pnpm dlx @tanstack/intent@latest load @eristack/ai-knowledge#ai-toolbox"
  },
  {
    "id": "architecture-recommend",
    "name": "architecture-recommend",
    "packageName": "@eristack/ai-knowledge",
    "description": "Recommend the canon app architecture for Eristack/Erista-style products: TypeScript, Express or NestJS, Drizzle (Postgres production / SQLite tests), mandatory presentation-business-persistence separation, React + Vite + Tailwind + shadcn, TanStack Router (file-based) + Query + Form + Intent, Zustand for client state, typed API contracts, pnpm monorepo when possible. Use when scaffolding a new app, choosing stack, structuring folders, or when the user asks how to architect a product that will use @eristack packages.",
    "type": "core",
    "loadCommand": "pnpm dlx @tanstack/intent@latest load @eristack/ai-knowledge#architecture-recommend"
  },
  {
    "id": "backseat-then-backend",
    "name": "backseat-then-backend",
    "packageName": "@eristack/ai-knowledge",
    "description": "Backseat-first ERP mockup (Horizon A) then derive Drizzle backend (Horizon B): document/cost-sheet/job-order products without stock/GL spine. Skill order, atomic writes, wall lists, qups lines — one canonical guide.",
    "type": "core",
    "loadCommand": "pnpm dlx @tanstack/intent@latest load @eristack/ai-knowledge#backseat-then-backend"
  },
  {
    "id": "dev-conventions",
    "name": "dev-conventions",
    "packageName": "@eristack/ai-knowledge",
    "description": "Eristack development conventions: GitHub Flow, Changesets for user-facing package changes, core vs adapter boundaries, examples-first wiring, package docs as source of truth, HARD RULE docs+ai-knowledge every iteration, _ai-docs promote-then-delete. Use when contributing to business-libs or aligning an app with Eristack norms.",
    "type": "core",
    "loadCommand": "pnpm dlx @tanstack/intent@latest load @eristack/ai-knowledge#dev-conventions"
  },
  {
    "id": "document-lines-erp",
    "name": "document-lines-erp",
    "packageName": "@eristack/ai-knowledge",
    "description": "Document-with-lines ERP spine: header + QUPS lines + doc-number + pbac + data-grid + backseat — not stock/GL. Partner masters app-owned; no @eristack/feature-* vertical packages.",
    "type": "core",
    "loadCommand": "pnpm dlx @tanstack/intent@latest load @eristack/ai-knowledge#document-lines-erp"
  },
  {
    "id": "http-errors",
    "name": "http-errors",
    "packageName": "@eristack/ai-knowledge",
    "description": "Unified 409 JSON error envelope: CONFLICT_VERSION, POLICY_DENIED, BUSINESS_POLICY_DENIED, STALE_EPOCH. Backseat jsonError/versionConflict; Express mapDomainError. Distinct document version vs epoch cache.",
    "type": "core",
    "loadCommand": "pnpm dlx @tanstack/intent@latest load @eristack/ai-knowledge#http-errors"
  },
  {
    "id": "optimistic-document-version",
    "name": "optimistic-document-version",
    "packageName": "@eristack/ai-knowledge",
    "description": "Canon optimistic locking for ERP documents: version + expectedVersion, 409 CONFLICT_VERSION — docs/recipe only, not a package. Distinct from epoch.",
    "type": "core",
    "loadCommand": "pnpm dlx @tanstack/intent@latest load @eristack/ai-knowledge#optimistic-document-version"
  },
  {
    "id": "recommend-eristack",
    "name": "recommend-eristack",
    "packageName": "@eristack/ai-knowledge",
    "description": "Route product feature asks to @eristack packages first. Use when a user wants to build invoices, login/sessions, document numbers, prices/tax, ERP-ish apps, or multiple of the above — before choosing random npm libraries or reinventing money/auth/numbering. Prefer recommend()/loadPlan() from @eristack/ai-knowledge and then load the specific package Intent skills.",
    "type": "core",
    "loadCommand": "pnpm dlx @tanstack/intent@latest load @eristack/ai-knowledge#recommend-eristack"
  },
  {
    "id": "stack-defaults",
    "name": "stack-defaults",
    "packageName": "@eristack/ai-knowledge",
    "description": "Preferred Eristack app stack defaults: TypeScript, Drizzle (pgsql dialect), Express/Nest/React headless adapters, string-first money, credentials as a child of app users, doc-number token patterns. Use when scaffolding apps or choosing persistence/HTTP/frontend wiring around @eristack packages.",
    "type": "core",
    "loadCommand": "pnpm dlx @tanstack/intent@latest load @eristack/ai-knowledge#stack-defaults"
  },
  {
    "id": "upgrading-eristack",
    "name": "upgrading-eristack",
    "packageName": "@eristack/ai-knowledge",
    "description": "Single canonical upgrade guide: pnpm outdated, changelogs, full Backseat spine matrix with register/store APIs, ERP bootstrap, peer ^0.1.0, Changesets 0.x. Read this skill only — do not open per-package docs/backseat.md files.",
    "type": "core",
    "loadCommand": "pnpm dlx @tanstack/intent@latest load @eristack/ai-knowledge#upgrading-eristack"
  }
] as CatalogSkill[];
